var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineAssignmentReturnCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H24V18H20V15L15 20L20 25V22ZM27 11H22.82C22.4 9.84 21.3 9 20 9C18.7 9 17.6 9.84 17.18 11H13C12.86 11 12.73 11.01 12.6 11.04C12.21 11.12 11.86 11.32 11.59 11.59C11.41 11.77 11.26 11.99 11.16 12.23C11.06 12.46 11 12.72 11 13V27C11 27.27 11.06 27.54 11.16 27.78C11.26 28.02 11.41 28.23 11.59 28.42C11.86 28.69 12.21 28.89 12.6 28.97C12.73 28.99 12.86 29 13 29H27C28.1 29 29 28.1 29 27V13C29 11.9 28.1 11 27 11ZM20 10.75C20.41 10.75 20.75 11.09 20.75 11.5C20.75 11.91 20.41 12.25 20 12.25C19.59 12.25 19.25 11.91 19.25 11.5C19.25 11.09 19.59 10.75 20 10.75ZM27 27H13V13H27V27Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineAssignmentReturnCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-assignment_return_circle-40px.f630d9e680e24b1269eb8b319858378d.svg";
export { ForwardRef as ReactComponent };